<!-- 员工信息管理 -->
<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form-model layout="inline" @keyup.enter.native="searchQuery(false, false)">
        <a-row :gutter="24">
          <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6" :xxl="4" :style="isModal ? 'width: 320px;' : ''">
            <a-form-model-item label="　关键字">
              <a-input placeholder="员工编号、姓名模糊查询" v-model="queryParam.keyword"></a-input>
            </a-form-model-item>
          </a-col>

          <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6" :xxl="4" :style="isModal ? 'width: 320px;' : ''">
            <a-form-model-item label="所属部门">
              <j-input-popup
                v-model="departs"
                component="SelectDepartTreeModal"
                placeholder="请选择所属部门"
                :params="{
                  companyId: '',
                  departName: '',
                  multiFlg: '1',
                  departFlg: '1',
                  searchFlg: '0',
                }"
              ></j-input-popup>
            </a-form-model-item>
          </a-col>

          <!--<a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="12" :xxl="14" :style="isModal ? 'width: 50%;' : ''">
            <a-form-model-item label="显示已离职人员">
              <a-switch
                :checkedChildren="$t('disp.yes')"
                :unCheckedChildren="$t('disp.no')"
                v-model="queryParam.showRetired"
                :disabled="isModal"
              />
            </a-form-model-item>
          </a-col>-->

          <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6" :xxl="4" :style="isModal ? 'width: 320px;' : ''">
            <a-form-model-item label="联系方式">
              <a-input placeholder="联系电话、邮箱模糊查询" v-model="queryParam.phoneOrMail"></a-input>
            </a-form-model-item>
          </a-col>

          <a-col :xs="0" :sm="0" :md="0" :lg="0" :xl="6" :xxl="12" :style="isModal ? 'width: calc(100% - 960px);' : ''">
            <a-form-model-item>
              <span></span>
            </a-form-model-item>
          </a-col>

          <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6" :xxl="4" :style="isModal ? 'width: 320px;' : ''">
            <a-form-model-item label="合同期间">
              <a-input-group compact>
                <a-date-picker v-model="queryParam.conDateMin" placeholder="下限值" />
                <a-date-picker v-model="queryParam.conDateMax" placeholder="上限值" />
              </a-input-group>
            </a-form-model-item>
          </a-col>

          <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6" :xxl="4" :style="isModal ? 'width: 320px;' : ''">
            <a-form-model-item label="公司职位">
              <j-dict-select-tag
                mode="multiple"
                :filterOption="filterOption"
                v-model="queryParam.positionIds"
                :placeholder="this.$t('disp.ph.select', ['公司' + $t('disp.position')])"
                :dictCode="$getPosition()"
              />
            </a-form-model-item>
          </a-col>

          <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6" :xxl="4" :style="isModal ? 'width: 320px;' : ''">
            <a-form-model-item label="人员角色">
              <j-dict-select-tag
                mode="multiple"
                :filterOption="filterOption"
                v-model="queryParam.roleIds"
                :placeholder="this.$t('disp.ph.select', ['人员角色'])"
                dictCode="sys_role;role_name;id;del_flag = 0 and system_flag = false order by role_name asc"
              />
            </a-form-model-item>
          </a-col>

          <!--<a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6" :xxl="4" :style="isModal ? 'width: 250px;' : ''">
            <a-form-model-item label="　　条线">
              <j-dict-select-tag
                mode="multiple"
                :filterOption="filterOption"
                v-model="queryParam.bizLineIds"
                :placeholder="this.$t('disp.ph.select', ['条线'])"
                :dictCode="$getBizLine()"
              />
            </a-form-model-item>
          </a-col>-->

          <a-col :xs="24" :sm="24" :style="isModal || parent == 'AddressBook' ? 'width: 192px;' : ''">
            <a-form-model-item :wrapperCol="{ span: 24 }" class="width-fit-content">
              <a-button type="primary" @click="searchQuery(false, false)" icon="search">{{
                $t('disp.btn.search')
              }}</a-button>

              <a-button @click="searchReset" icon="stop">{{ $t('disp.btn.reset') }}</a-button>

              <template v-if="!isModal && parent != 'AddressBook'">
                <!--<a-divider type="vertical"></a-divider>

                <a-button @click="$createWF('EmployeeBeforeEntryApply')" type="primary">
                  <span class="mdi mdi-account-check-outline"></span>
                  <span>入职审批</span>
                </a-button>

                <a-button @click="$createWF('EmployeeEntryApply')" type="primary" icon="idcard">入职手续</a-button>

                <a-button @click="$createWF('EmployeeRegularApply')" type="primary">
                  <span class="mdi mdi-account-switch-outline"></span>
                  <span>转正审批</span>
                </a-button>-->

                <a-divider type="vertical"></a-divider>

                <a-upload
                  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                  :customRequest="customRequest"
                  @change="customChange"
                  :disabled="uploadDisabled"
                  :fileList="null"
                  style="display: inline-block; margin-right: 8px"
                  v-if="$getLoginUser().editableFlag == '1'"
                >
                  <a-button type="primary" :icon="uploadIcon" :disabled="uploadDisabled">导入</a-button>
                </a-upload>
                <a-popover v-else trigger="click" placement="topLeft">
                  <template slot="content">
                    <div style="color: var(--color-red)">导入功能暂不面向大众开放，</div>
                    <div>员工信息的录入原则上需要走入职流程，</div>
                    <div>如有批量补录需求，请填写导入模板并提交至 <b>数字科技部</b></div>
                  </template>
                  <a-button type="primary" :icon="uploadIcon">导入</a-button>
                </a-popover>

                <a-popover placement="topLeft">
                  <template slot="content">
                    <div>导出时间取决于导出条数，</div>
                    <div>每秒钟大概可以处理 <span style="color: var(--color-orange)">100 条</span> 数据</div>
                  </template>
                  <a-button type="primary" icon="cloud-download" @click="handleExport">导出</a-button>
                </a-popover>

                <a-button @click="$downloadTemplate('员工信息导入模板.xlsx')" icon="download">下载导入模板</a-button>
                <a-button @click="updateWorkAddr()" v-if="$getLoginUser().editableFlag == '1'">更新工作地点</a-button>
                <a-button @click="exportUnionStaff()" icon="cloud-download" v-if="$hasAuth('EmployeeManage:ExportUnionStaff')">导出工会人员</a-button>
              </template>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="24"> </a-row>
      </a-form-model>
    </div>

    <div>
      <div style="display: inline-block; white-space: nowrap; margin-right: 30px">
        <div style="font-size: 14px; margin-bottom: 4px; color: black; display: inline-block">
          <JSharp style="margin-left: 1px; position: relative; top: -1px"></JSharp>
          <span>在职状态：</span>
        </div>
        <div class="div-flow-filter">
          <div
            class="category"
            :class="queryParam.status == '所有记录' ? 'active' : ''"
            @click="queryParam.status = '所有记录'"
          >
            <span>所有记录</span>
          </div>

          <div
            class="category"
            :class="queryParam.status == '在职' ? 'active' : ''"
            @click="queryParam.status = '在职'"
          >
            <span><a-icon type="check-circle" theme="filled" style="color: var(--color-green)" />在职</span>
          </div>

          <!--<div
            class="category"
            :class="queryParam.status == '试用期' ? 'active' : ''"
            @click="queryParam.status = '试用期'"
          >
            <span><a-icon type="clock-circle" theme="filled" style="color: var(--color-cyan)" />试用期</span>
          </div>-->

          <div
            class="category"
            :class="queryParam.status == '离职' ? 'active' : ''"
            @click="queryParam.status = '离职'"
          >
            <span
              ><a-icon type="stop" theme="filled" style="color: rgba(0, 0, 0, 0.2); transform: scale(0.98)" />离职</span
            >
          </div>
        </div>
      </div>

      <div style="display: inline-block; white-space: nowrap; margin-right: 30px" v-if="!isModal">
        <div style="font-size: 14px; margin-bottom: 4px; color: black; display: inline-block">
          <JSharp style="margin-left: 1px; position: relative; top: -1px"></JSharp>
          <span>劳动合同：</span>
        </div>
        <div class="div-flow-filter">
          <div
            class="category"
            :class="queryParam.statusContractUpload == '所有记录' ? 'active' : ''"
            @click="queryParam.statusContractUpload = '所有记录'"
          >
            <span>所有记录</span>
          </div>

          <div
            class="category"
            :class="queryParam.statusContractUpload == '已上传' ? 'active' : ''"
            @click="queryParam.statusContractUpload = '已上传'"
          >
            <span><a-icon type="check-circle" theme="filled" style="color: var(--color-green)" />已上传</span>
          </div>

          <div
            class="category"
            :class="queryParam.statusContractUpload == '未上传' ? 'active' : ''"
            @click="queryParam.statusContractUpload = '未上传'"
          >
            <span><a-icon type="clock-circle" theme="filled" style="color: var(--color-orange)" />未上传</span>
          </div>
        </div>
      </div>

      <div style="display: inline-block; white-space: nowrap; margin-right: 30px">
        <div style="font-size: 14px; margin-bottom: 4px; color: black; display: inline-block">
          <JSharp style="margin-left: 1px; position: relative; top: -1px"></JSharp>
          <span>合同剩余：</span>
        </div>
        <div class="div-flow-filter">
          <div
            class="category"
            :class="queryParam.statusContract == '所有记录' ? 'active' : ''"
            @click="queryParam.statusContract = '所有记录'"
          >
            <span>所有记录</span>
          </div>

          <div
            class="category"
            :class="queryParam.statusContract == '一个月' ? 'active' : ''"
            @click="queryParam.statusContract = '一个月'"
          >
            <span><a-icon type="meh" theme="filled" style="color: var(--color-orange)" />一个月</span>
          </div>

          <div
            class="category"
            :class="queryParam.statusContract == '已超期' ? 'active' : ''"
            @click="queryParam.statusContract = '已超期'"
          >
            <span><a-icon type="frown" theme="filled" style="color: var(--color-red)" />已超期</span>
          </div>
        </div>
      </div>

      <div style="display: inline-block; white-space: nowrap">
        <div style="font-size: 14px; margin-bottom: 4px; color: black; display: inline-block">
          <JSharp style="margin-left: 1px; position: relative; top: -1px"></JSharp>
          <span>转正状态：</span>
        </div>
        <div class="div-flow-filter">
          <div
            class="category"
            :class="queryParam.statusRegular == '所有记录' ? 'active' : ''"
            @click="queryParam.statusRegular = '所有记录'"
          >
            <span>所有记录</span>
          </div>

          <div
            class="category"
            :class="queryParam.statusRegular == '一星期' ? 'active' : ''"
            @click="queryParam.statusRegular = '一星期'"
          >
            <span><a-icon type="clock-circle" theme="filled" style="color: var(--color-cyan)" />一星期</span>
          </div>

          <div
            class="category"
            :class="queryParam.statusRegular == '已超期' ? 'active' : ''"
            @click="queryParam.statusRegular = '已超期'"
          >
            <span><a-icon type="exclamation-circle" theme="filled" style="color: var(--color-blue)" />已超期</span>
          </div>
        </div>
      </div>
    </div>

    <div>
      <div class="ant-alert ant-alert-info div-selected-info" v-if="isModal">
        <i class="anticon anticon-info-circle ant-alert-icon"></i>
        {{ this.$t('disp.selected') }}
        <a class="a-selected-info">{{ selectedRowKeys.length }}</a>
        {{ this.$t('disp.item') }}
        <a @click="onClearSelected">{{ this.$t('disp.clear') }}</a>
      </div>

      <a-table
        ref="table"
        tableLayout="auto"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        @change="handleTableChange"
        :rowClassName="rowClassName"
        :rowSelection="
          isModal
            ? {
                selectedRowKeys: selectedRowKeys,
                onChange: onSelectChange,
                type: isMulti ? 'checkbox' : 'radio',
              }
            : null
        "
      >
        <a-table-column key="username" data-index="username" title="员工编号">
          <template slot-scope="text, record">
            <a @click="handleEdit(record, record.recordEditable)" v-if="!isModal">{{ record.username }}</a>
            <span v-else>{{ record.username }}</span>
          </template>
        </a-table-column>

        <a-table-column key="realname" data-index="realname" title="员工姓名">
          <div slot-scope="text, record" style="font-size: 14px; white-space: nowrap">
            <div style="width: 26px; display: inline-block; margin-right: 10px">
              <a-tag color="blue" style="min-width: unset; transform: scale(0.9)" v-if="record.sex == 1"
                ><span class="mdi mdi-gender-male"></span
              ></a-tag>
              <a-tag color="pink" style="min-width: unset; transform: scale(0.9)" v-if="record.sex == 2"
                ><span class="mdi mdi-gender-female"></span
              ></a-tag>
            </div>

            <span>{{ record.realname }}</span>
          </div>
        </a-table-column>

        <a-table-column key="phone" data-index="phone" title="联系方式" v-if="!isModal">
          <div slot-scope="text, record" style="font-size: 13px; white-space: nowrap">
            <span>{{ record.phone }}</span>
            <div class="extraNote" v-if="record.email">{{ record.email }}</div>
          </div>
        </a-table-column>

        <a-table-column
          key="conStartDate"
          data-index="conStartDate"
          title="合同期间"
          v-if="!isModal && parent != 'AddressBook'"
        >
          <div slot-scope="text, record" style="font-size: 13px; white-space: nowrap">
            <span v-if="record.conStartDate">{{ moment(record.conStartDate).format('YYYY-MM-DD') }}</span>
            <div class="extraNote" v-if="record.conEndDate" :style="getContractStyle(record)">
              {{ moment(record.conEndDate).format('YYYY-MM-DD') }}
            </div>
          </div>
        </a-table-column>

        <a-table-column
          key="entryDay"
          data-index="entryDay"
          title="入离职时间"
          v-if="!isModal && parent != 'AddressBook'"
        >
          <div slot-scope="text, record" style="font-size: 13px; white-space: nowrap">
            <span v-if="record.entryDay">{{ moment(record.entryDay).format('YYYY-MM-DD') }}</span>
            <div class="extraNote" v-if="record.retirementDay">
              {{ moment(record.retirementDay).format('YYYY-MM-DD') }}
            </div>
          </div>
        </a-table-column>

        <a-table-column
          key="regularStartDate"
          data-index="regularStartDate"
          title="转正时间"
          v-if="!isModal && parent != 'AddressBook'"
        >
          <div slot-scope="text, record" style="font-size: 13px; white-space: nowrap">
            <span v-if="record.regularStartDate" :style="getRegularStyle(record)">{{
              moment(record.regularStartDate).format('YYYY-MM-DD')
            }}</span>
          </div>
        </a-table-column>

        <a-table-column key="workAddr" data-index="workAddr" title="工作地点" align="left">
          <div slot-scope="text, record" style="font-size: 13px">{{ record.workAddr }}</div>
        </a-table-column>

        <a-table-column key="relations" data-index="relations" align="left">
          <span slot="title">
            <span>所属信息</span>
          </span>
          <template slot-scope="text, record">
            <div v-for="row in record.relations" :key="row.id" style="margin-right: 8px; display: inline-block">
              <div class="relation-wrapper">
                <a-tag color="purple" v-if="row.departId == currentDeptId && queryParam.includeChildren">{{
                  row.departName
                }}</a-tag>
                <a-tag color="blue" v-else>{{ row.departName }}</a-tag>
                <a-tag color="green" v-if="row.positionName">{{ row.positionName }}</a-tag>
                <a-tag color="orange" v-if="row.bizLineName">{{ row.bizLineName }}</a-tag>
              </div>
            </div>
          </template>
        </a-table-column>

        <a-table-column key="roles" data-index="roles" title="角色">
          <template slot-scope="text, record">
            <template v-if="record.roles.length > 0">
              <a-tag color="pink" class="tag-role" v-for="row in record.roles" :key="row.id">{{ row.roleName }}</a-tag>
            </template>
            <JEmpty v-else></JEmpty>
          </template>
        </a-table-column>

        <a-table-column
          key="postLevel"
          data-index="postLevel"
          title="职级"
          :width="60"
          align="center"
          v-if="!isModal && parent != 'AddressBook'"
        >
          <template slot-scope="text, record">
            <a-tag color="purple" v-if="record.postLevel">{{ record.postLevel }}</a-tag>
          </template>
        </a-table-column>

        <a-table-column
          key="delFlag"
          data-index="delFlag"
          title="状态"
          :width="90"
          align="center"
          v-if="parent != 'AddressBook'"
        >
          <template slot-scope="text, record">
            <!-- 系统用户 -->
            <a-tag color="blue" v-if="record.delFlag == '0' && !record.employeeType && !record.entryDay"
              >系统用户</a-tag
            >
            <!-- 离职 -->
            <a-tag v-else-if="record.delFlag == '1' && record.retirementDay">离职</a-tag>
            <!-- 削除 -->
            <a-tag v-else-if="record.delFlag == '1' && !record.retirementDay">删除</a-tag>
            <!-- 等待入职 -->
            <a-tag color="orange" v-else-if="record.delFlag == '-1'">等待入职</a-tag>
            <!-- 即将离职 -->
            <a-tag
              color="red"
              v-else-if="
                record.delFlag == '0' &&
                record.retirementDay &&
                moment(record.retirementDay).isAfter(moment(new Date()))
              "
              >即将离职</a-tag
            >
            <!-- 试用期 -->
            <a-tag color="cyan" v-else-if="!record.regularFlag">试用期</a-tag>
            <!-- 在职 -->
            <a-tag color="green" v-else>在职</a-tag>
          </template>
        </a-table-column>

        <a-table-column key="action" title="操作" :width="46" v-if="!isModal && parent != 'AddressBook'" align="center">
          <div slot-scope="text, record" style="white-space: nowrap">
            <a @click="handleEdit(record, true)" v-if="record.recordEditable">{{ $t('disp.btn.edit') }}</a>
            <a @click="handleEdit(record, false)" v-else>详细</a>
          </div>
        </a-table-column>
      </a-table>
    </div>

    <ApplyModal ref="ApplyModal" @searchQuery="searchQuery(true, true)"></ApplyModal>
    <EmployeeModal ref="modalForm" @ok="searchQuery(true, true)"></EmployeeModal>
    <JSelectExportDate ref="JSelectExportDate" @emit="emitFromJSelectExportDate"></JSelectExportDate>
  </a-card>
</template>

<script>
import { putAction, postAction, getAction } from '@/api/manage'
import { tableMixin } from '@/mixins/tableMixin'
import EmployeeModal from './EmployeeModal'
import JSelectExportDate from '@/components/JSelectExportDate'

export default {
  name: 'EmployeeManage',
  mixins: [tableMixin],
  components: {
    EmployeeModal,
    JSelectExportDate,
  },
  props: {
    // 是否弹出框
    isModal: {
      type: Boolean,
      default: false,
    },
    // 是否多选
    isMulti: {
      type: Boolean,
      default: false,
    },
    // 父组件
    parent: {
      type: String,
      default: '',
    },
    // 选中行
    selectionRows: {
      type: Array,
      default: [],
    },
    // 排除组织ID
    excludeDepartId: {
      type: String,
      default: '',
    },
    // 排除角色ID
    excludeRoleId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      // 导入excel时的icon图标
      uploadIcon: 'cloud-upload',
      // 导入excel时是否禁用上传按钮
      uploadDisabled: false,
      departs: [],
      queryParam: {
        keyword: '',
        departIds: '',
        parent: '',
        excludeDepartId: '',
        excludeRoleId: '',
        status: '在职',
        statusContract: '所有记录',
        statusRegular: '所有记录',
        statusContractUpload: '所有记录',
      },
      url: {
        list: '/EmployeeManage/list',
        import: '/EmployeeManage/import',
        updateWorkAddr: '/EmployeeManage/updateWorkAddr',
        exportUnionStaff: '/EmployeeManage/exportUnionStaff',
      },
    }
  },
  watch: {
    departs: {
      handler(newVal, oldVal) {
        if (newVal && newVal.length > 0) {
          this.queryParam.departIds = XEUtils.map(newVal, (item) => item.id).join(',')
        } else {
          this.queryParam.departIds = ''
        }
      },
      immediate: false,
      deep: true,
    },
  },
  created: function () {
    this.queryParam.parent = this.parent
    this.queryParam.excludeDepartId = this.excludeDepartId
    this.queryParam.excludeRoleId = this.excludeRoleId

    if (this.selectionRows.length > 0) {
      this.selectedRowKeys = XEUtils.map(this.selectionRows, (item) => item.id)
    }
  },
  methods: {
    callbackBeforeSearchQuery() {
      if (this.parent == 'UserSaleManage') {
        window.dataFilterUrl = this.parent
      }
    },
    searchReset() {
      this.queryParam = {
        keyword: '',
        departIds: '',
        parent: this.parent,
        excludeDepartId: this.excludeDepartId,
        excludeRoleId: this.excludeRoleId,
        status: '在职',
        statusContract: '所有记录',
        statusRegular: '所有记录',
        statusContractUpload: '所有记录',
      }

      this.departs = []
    },
    handleEdit: function (record, editMode) {
      if (this.parent != 'AddressBook') {
        this.$refs.modalForm.edit(record, false, editMode)
        this.$refs.modalForm.title = editMode ? this.$t('disp.btn.edit') : '详细'
        this.$refs.modalForm.disableSubmit = false
      }
    },
    /**
     * 自定义导入文件方法
     * @param data 上传的 excel 文件
     */
    customRequest(data) {
      if (this.loading) {
        return
      } else {
        this.loading = true
      }

      const file = data.file // 需要上传的 excel 文件
      const formData = new FormData()
      formData.append('file', file)
      postAction(this.url.import + '?', formData)
        .then((res) => {
          if (res.success) {
            this.$message.success('导入成功')
            this.searchQuery(true, false)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleExport() {
      this.queryParam.exportDate = moment().format('YYYY-MM')

      if (this.loading) {
        return
      } else {
        this.loading = true
      }

      getAction(this.url.list, this.queryParam)
        .then((res) => {
          if (res.success) {
            // 处理成功
            downloadFile(res.message)
            this.$message.success(this.$t('msg.operation.success'))
          }
        })
        .finally(() => {
          this.loading = false
          this.queryParam.exportDate = undefined
        })
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].data.attrs.title.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    getContractStyle(record) {
      // 已离职
      if (record.delFlag == '1') {
        return ''
      }
      // 合同已过期
      else if (moment(record.conEndDate).format('YYYY-MM-DD') < moment().format('YYYY-MM-DD')) {
        return 'color: var(--color-red)'
      }
      // 一个月内过期
      else if (moment(record.conEndDate).diff(moment(), 'M') == 0) {
        return 'color: var(--color-orange)'
      }
    },
    getRegularStyle(record) {
      // 已转正 或 已离职
      if (record.delFlag == '1' || record.regularFlag) {
        return ''
      }
      // 已过期
      else if (moment(record.regularStartDate).format('YYYY-MM-DD') < moment().format('YYYY-MM-DD')) {
        return 'color: var(--color-blue)'
      }
      // 一星期内过期
      else if (
        !XEUtils.getDateDiff(moment().format('YYYY-MM-DD'), moment(record.regularStartDate).format('YYYY-MM-DD')).dd ||
        XEUtils.getDateDiff(moment().format('YYYY-MM-DD'), moment(record.regularStartDate).format('YYYY-MM-DD')).dd <= 7
      ) {
        return 'color: var(--color-cyan)'
      }
    },
    /**
     * 修改工作地址方法
     */
    updateWorkAddr() {
      if (this.loading) {
        return
      } else {
        this.loading = true
      }

      postAction(this.url.updateWorkAddr, {})
        .then((res) => {
          if (res.success) {
            this.$message.success('更新成功')
            this.searchQuery(true, false)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 按模板导出工会人员
    exportUnionStaff() {
      this.$refs.JSelectExportDate.handleOpen('month')
    },
    emitFromJSelectExportDate(selected) {
      if (this.loading) {
        return
      } else {
        this.loading = true
      }

      let param = {}
      param.exportDate = selected

      getAction(this.url.exportUnionStaff, {exportDate : selected})
        .then((res) => {
          if (res.success) {
            // 处理成功
            downloadFile(res.message)
            this.$message.success(this.$t('msg.operation.success'))
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>
<style scoped lang="less">
.tag-role {
  width: auto !important;
  margin: 2px 3px 2px 0 !important;
}

.div-flow-filter {
  display: inline-block;

  .category {
    min-width: 87px;
    display: inline-block;
    //background: #f8f8f8;
    padding: 5px 10px;
    font-size: 14px;
    margin-right: 8px;
    margin-bottom: 8px;
    border-radius: 6px;
    cursor: pointer;
    //min-width: 100px;
    text-align: center;
    transition: all 0.3s;
    color: #000;
    background: #f8f8f8;

    i {
      margin-right: 7px;
    }

    &.active {
      color: var(--color-primary-6);
      background: var(--color-primary-1);
    }

    &:hover {
      background: var(--color-primary-1);
    }

    .num {
      color: var(--color-green-6);
      font-size: 13px;
      position: relative;
      letter-spacing: 0px;
    }
  }
}
</style>
